import {observer} from "mobx-react";
import {useScreenMediaQueriesChecks} from "../../../../hooks/use-screen-media-queries-checks.hook";
import {AirlineLogoLargeMulticolorIcon} from "../../../../assets/svg/airline-logo-large-multicolor.icon";
import {AirlineLogoSmallMulticolorIcon} from "../../../../assets/svg/airline-logo-small-multicolor.icon";
import React from "react";
import styled from "styled-components";

const SmallLogoBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    cursor: pointer;
`

const LargeLogoBox = styled.div`
    cursor: pointer;
`


interface PageHeaderLogoComponentProps {
    useLargeLogo: boolean;
    onClick?: () => void;
}

export const PageHeaderLogoComponent: React.FC<PageHeaderLogoComponentProps> = observer((props) => {
    const mediaQuery = useScreenMediaQueriesChecks();

    if(props.useLargeLogo) {
        return (
            <LargeLogoBox key={"LOGO_LARGE"} onClick={props.onClick}>
                <AirlineLogoLargeMulticolorIcon size={mediaQuery.smallScreen ? 2 : 2.5}/>
            </LargeLogoBox>
        )
    }

    return (
        <SmallLogoBox key={"LOGO_SMALL"} onClick={props.onClick}>
            <AirlineLogoSmallMulticolorIcon size={1.5} sizeIsHeight={true}/>
        </SmallLogoBox>
    )
})